import { apiUrl } from "@api";
import Button from "@components/button";
import PaymentIcon from "@components/icons/payment-icon";
import { useDownloadFile } from "@hooks/use-download-file";

function OrderHistoryInvoiceButton({
  id,
  oid,
  invoiceNumber,
  small,
}: {
  id: string;
  oid: string;
  invoiceNumber: string;
  small?: boolean;
}) {
  const { download, isLoading, statusLabel } = useDownloadFile();
  return (
    <Button
      outline
      isLoading={isLoading}
      left={<PaymentIcon size={19} color="$primary" />}
      py="$1"
      px="$1"
      spacing={small ? "$1" : undefined}
      description={statusLabel}
      onPress={() => {
        download({
          url: `${apiUrl}/account/order-invoice/${id}`,
          fileName: `Factuur-${invoiceNumber}.pdf`,
          withToken: true,
        });
      }}
    >
      {small ? "" : "Download factuur"}
    </Button>
  );
}
export default OrderHistoryInvoiceButton;
